import { Button } from "@app/ui";
import type { I18nKey } from "../../lib/language.js";
import { useI18n } from "../../lib/useI18n.js";

/** Common reminder lead times (minutes before due). 0 = at due time. */
const PRESETS: { labelKey: I18nKey; minutes: number; count?: number; fallback?: string }[] = [
  { labelKey: "reminder.atTime", minutes: 0 },
  { labelKey: "reminder.minBefore", minutes: 5, count: 5 },
  { labelKey: "reminder.minBefore", minutes: 10, count: 10 },
  { labelKey: "reminder.minBefore", minutes: 30, count: 30 },
  { labelKey: "reminder.hourBefore", minutes: 60, count: 1 },
  { labelKey: "reminder.dayBefore", minutes: 1440 },
];

/** Multi-select of reminder lead times. Each selected entry fires its own notification. */
export function ReminderField({ value, onChange }: { value: number[]; onChange: (v: number[]) => void }) {
  const { t } = useI18n();
  function toggle(min: number) {
    onChange(
      value.includes(min)
        ? value.filter((m) => m !== min)
        : [...value, min].sort((a, b) => a - b),
    );
  }
  return (
    <div className="flex flex-col gap-1">
      <p className="text-xs text-muted-foreground">{t("taskForm.remindBeforeDue")}</p>
      <div className="flex flex-wrap items-center gap-1.5">
        {PRESETS.map((p) => (
          <Button
            key={p.minutes}
            type="button"
            size="sm"
            variant={value.includes(p.minutes) ? "primary" : "outline"}
            onClick={() => toggle(p.minutes)}
          >
            {t(p.labelKey, { count: p.count })}
          </Button>
        ))}
      </div>
    </div>
  );
}
